import {
  ChartCandlestickIcon,
  ChartLineData01Icon,
  Home01Icon,
  Logout01Icon,
  MoneyAdd01Icon,
  MoneySend01Icon,
  Settings02Icon,
  Target02Icon,
} from "@hugeicons/core-free-icons";
import HugeIcon from "src/components/HugeIcon";
import NiceModal from "@ebay/nice-modal-react";
import {
  DEPOSIT_CASH_MODAL,
  WITHDRAW_CASH_MODAL,
} from "src/components/Modals/CashFlows";

import { TRouteItem } from "./types";

/**
 * The rail's glyph.
 *
 * The icons here were seven hand-drawn SVG assets plus three inline
 * components, and they were not one set: some carried no intrinsic size and
 * rendered at 32x35, others were drawn at 14x16, so no two rows in the rail
 * had a glyph the same size. They were also filled rather than stroked,
 * which is why the old styling had to reach in and set `fill`.
 *
 * One size, one weight, one library — football's 17px at a 1.6 stroke,
 * taking its colour from the row.
 */
const NavIcon = ({
  icon,
}: {
  icon: Parameters<typeof HugeIcon>[0]["icon"];
}) => <HugeIcon icon={icon} size={17} strokeWidth={1.6} />;

export type MenuTypes = "analytics" | "invest" | "cash";
export type IRouteItem = Record<MenuTypes, TRouteItem[]>;

export const routes: IRouteItem = {
  analytics: [
    {
      key: "dashboard",
      path: "/dashboard",
      name: "Dashboard",
      icon: <NavIcon icon={Home01Icon} />,
      type: "analytics",
    },
  ],
  invest: [
    {
      key: "Markets",
      path: "/markets",
      name: "Markets",
      icon: <NavIcon icon={ChartLineData01Icon} />,
      type: "invest",
    },
    {
      key: "GoalBased",
      path: "/goal-based-investment",
      name: "Goal-Based",
      icon: <NavIcon icon={Target02Icon} />,
      type: "invest",
    },
    {
      key: "Brokerage",
      path: "/brokerage",
      name: "Trading",
      icon: <NavIcon icon={ChartCandlestickIcon} />,
      type: "invest",
    },
  ],
  cash: [
    /* These two open over whatever the reader is looking at rather than
       navigating away from it — see the note in Modals/CashFlows. The paths
       stay on the items so the rail still marks the row when someone arrives
       by URL. */
    {
      key: "deposit",
      path: "/deposit",
      name: "Deposit Cash",
      icon: <NavIcon icon={MoneyAdd01Icon} />,
      type: "cash",
      action: () => NiceModal.show(DEPOSIT_CASH_MODAL),
    },
    {
      key: "withdraw",
      path: "/withdraw",
      name: "Withdraw Cash",
      icon: <NavIcon icon={MoneySend01Icon} />,
      type: "cash",
      action: () => NiceModal.show(WITHDRAW_CASH_MODAL),
    },
  ],
};
export const settings: TRouteItem[] = [
  {
    key: "settings",
    path: "/settings",
    name: "Settings",
    icon: <NavIcon icon={Settings02Icon} />,
    type: "settings",
  },
  {
    key: "LogOut",
    path: "/logout",
    name: "Log out",
    icon: <NavIcon icon={Logout01Icon} />,
    type: "settings",
  },
];
